module.exports = __webpack_public_path__ + "img/2025-11-17c_15.febac5a4.jpg";